import React from 'react';
import PropTypes from 'prop-types';
import BaseNext from '../base-next';

const LastNameNext = props => {
  const { onChange, value, error, touched, onBlur, isDisabled } = props;
  return (
    <BaseNext
      isDisabled={isDisabled}
      data-cv-test="lastName"
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      touched={touched}
      error={error}
      id="last"
      inputMode="text"
      labelText="Last Name"
      inputTip="enter exactly as it appears on your driver's license"
      maxLength={31}
    />
  );
};

LastNameNext.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string.isRequired,
  touched: PropTypes.bool,
  isDisabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

LastNameNext.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  touched: false,
  error: false,
  isDisabled: false
};

export default LastNameNext;
